<template>
	<div class="sliderbox">
		<!-- 收起时状态 -->
		<sliderOff v-show="!isShowAllPart" ></sliderOff>
		<!-- 展开时状态 -->
		<sliderOn v-show="isShowAllPart" ></sliderOn>
	</div>
</template>
<script>
import { mapState} from 'vuex';
import sliderOff from './sliderOff';
import sliderOn from './sliderOn';
export default{
	components: {
		sliderOff,
		sliderOn
	},
	computed: {
		...mapState([
			'isShowAllPart'
		])
	}
};
</script>
<style lang ="scss">
@import '../../assets/style/public.scss';
.sliderbox {
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 100;
	background: $white;

}
</style>


// WEBPACK FOOTER //
// slider.vue?5587899a